/**
 * 模版市场-面包屑导航
 */

import React from 'react';
import { showRabbitBrandInfo } from 'utils/user';
import { isModuleHidden } from 'utils/hidden-modules';
import store from 'store';
import './nav-breadcrumb.less';

export default function NavBreadcrumb() {
  // 是否隐藏 创意云会员全场模板免费用
  const isVipGetFreeTemplateHidden = isModuleHidden('vip-get-free-template');
  const { storeTabs } = store.getState();
  const isBoughtPage = storeTabs.activeIndex === 0;

  return showRabbitBrandInfo() &&
    !isVipGetFreeTemplateHidden &&
    !isBoughtPage ? (
    <div className="store-tpls-breadcrumb-nav-container">
      <div className="breadcrumb-tip-text">
        <i className="icon-link-vip" />
        <a className="link-service" href="/service/" target="_blank">
          创意云会员模板免费用
        </a>
      </div>
    </div>
  ) : null;
}
